import { useEffect, useState } from "react";
import { message, Upload, UploadFile, UploadProps } from "antd";
import { RcFile } from "antd/es/upload";
import Dragger from "antd/es/upload/Dragger";
import { PlusOutlined } from "@ant-design/icons";

interface CustomUploadProps {
  name: string;
  onClick?: any;
  file?: UploadFile | null;
  onFileChange: (
    file: UploadFile | null | any,
    name: string,
    url?: string,
  ) => void;
  dimensions?: {
    width: number;
    height: number;
  };
  usePreview?: boolean;
  useDimensions?: boolean;
  multiple?: boolean;
  url?: string;
  handleRemove?: any;
  instructions?: string;
  onRemove?: any;
}

const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = (error) => {
      console.log("error", error);
      reject(error);
    };
  });

function UploadButton({
  name,
  onFileChange,
  dimensions: { width: widthDimension, height: heightDimension } = {
    width: 500,
    height: 500,
  },
  usePreview = true,
  useDimensions = false,
  url,
}: CustomUploadProps) {
  const [_, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  useEffect(() => {
    if (url) {
      setFileList([
        {
          uid: "-1",
          name: name,
          status: "done",
          url: url,
        },
      ]);
      onFileChange({}, name, url);
    }
  }, [url]);

  const props: UploadProps = {
    onRemove: (file) => {
      console.log("file", file);
      if (url) {
        onFileChange(null, name, undefined);
      } else {
        onFileChange(null, name);
      }
    },
    beforeUpload: async (file: any) => {
      if ((file && file.type === "image/png") || file.type === "image/jpeg") {
        const reader: any = new FileReader();

        const loadPromise = new Promise((resolve, reject) => {
          reader.onload = resolve;
          reader.onerror = reject;
        });

        reader.readAsDataURL(file);
        await loadPromise;

        const img = new Image();

        const imageLoadPromise = new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
        });

        img.src = reader.result;
        await imageLoadPromise;

        const width = img.width;
        const height = img.height;

        if (file.size >= 5242880) {
          message.error(`El tamaño de la imagen debe ser menor de 5MB`);
          return Upload.LIST_IGNORE;
        }

        if (
          (width !== widthDimension || height !== heightDimension) &&
          useDimensions
        ) {
          message.error(
            `Dimensiones invalidas, por favor escoge una imagen de ${widthDimension}px por ${heightDimension}px`,
          );
          return Upload.LIST_IGNORE;
        }
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file as RcFile);
          file.url = await getBase64(file as RcFile);
        }

        setPreviewTitle(
          file.name || file.url!.substring(file.url!.lastIndexOf("/") + 1),
        );

        onFileChange(file, name);

        return false;
      } else {
        onFileChange(file, name);
        return false;
      }
    },
    fileList: fileList,
    onChange: ({ fileList: newFileList }) => {
      setFileList(newFileList);
    },
    maxCount: 1,
  };

  const receipt = () => (
    <div>
      <Dragger {...props}>
        <p className="ant-upload-hint">Agrega aquí tu recibo de pago</p>
      </Dragger>
    </div>
  );

  const imageUploadButton = (
    <Upload listType={"picture-circle"} {...props}>
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    </Upload>
  );
  const element = usePreview ? imageUploadButton : receipt();
  return <div>{element}</div>;
}

export default UploadButton;
